import React, { Fragment } from 'react';

import { Moment } from 'moment';

import { KeyboardDatePicker } from "@material-ui/pickers";
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import CalendarToday from '@material-ui/icons/CalendarToday';

import SelectTimeCommon from '../common/SelectTimeCommon';
import DockOverloadCommon from '../common/DockOverloadCommon';
import CurrentDateTimeContainer from './CurrentDateTimeContainer';

import WebCamContainer from './cams/WebCamsContainer';

import style from './dockOverloadModal.module.css';

const styles = (theme: Theme) =>

  createStyles({
    datePicker: {
      marginTop:'-10px'
    },
    input: {
      '& input': {
        fontSize: '14px',
      }
    }
  });

interface DockOverloadModalProps { 
  classes: any;
  modalOpen: boolean;
  handleClose: Function;
  handleChange: (event: any) => void;
  forInfo: boolean;
  waitingTime: string;
  selectTime: string;
  selectedValue: number;
  handleChangeSelectedValue: (event: any) => void;
  selectedDate: Moment;
  handleChangeDate: (date: Moment) => void;
  dockLoad: Array<number>;
  workingHours: Array<{ end: string, start: string }>;
  cams: Array<{ url: string, description: string } | null>;
  ghaId: number;
};

const dockOverloadModal = (props: DockOverloadModalProps) => {

  const { classes } = props;

  const work: any= {}

  props.workingHours.forEach(item => {

    const start: number = Number(item.start.substring(0,2));
    const end: number = Number(item.end.substring(0,2));
    
    for( let i=start; i<end; i+=1) {
      work[i]=props.dockLoad[i]
    }
  });
  
  const selectComp: JSX.Element = props.forInfo ? 
    <Fragment>
      <span className={ style.selectTimeText }>Estimated dock activity: </span>
      <KeyboardDatePicker
        value={ props.selectedDate }
        format={ 'dddd MMM DD, YYYY' }
        onChange={ () => props.handleChangeDate }
        InputProps={{ 
          className: classes.input,
          disableUnderline: true
        }}
        autoOk
      />
    </Fragment> : 
    <Fragment>
      <span className={ style.selectTimeText }>Select Pick Up Time: </span>
      <SelectTimeCommon
        handleChange={ props.handleChange }
        selectTime={ props.selectTime }
        work={ work }
      />
    </Fragment>
    
  return (
    <Dialog
      open={ props.modalOpen }
      onClose={ () => props.handleClose(props.selectTime) }
      aria-labelledby="form-dialog-title"
      maxWidth={ 'xl' }
    >
      <DialogTitle id="form-dialog-title" >
        <div className={ style.dialogTitle }>
          <p className={ style.ticker }>
            <span className={ style.title }> ++++++ Heavy dock activity expected at time slots marked in red below - drivers are requested to avoid showing up at those times +++++++ </span>
          </p>  
          <IconButton aria-label="Close" onClick={ () => props.handleClose(props.selectTime) }>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className={ style.dialogContent }>
        <div className={ style.estimated }>
          { selectComp }
          <hr />
        </div>
        <div className={ style.currentWrapper }>
          <div className={ style.currentDate }>
            <CurrentDateTimeContainer />
     
            <hr className={ style.hr }/>
            <span>Current Wait Time: { props.waitingTime }</span>
          </div>
          <div className={ style.radioWrapper }>
            <DockOverloadCommon
              forInfo={ props.forInfo }
              selectedValue={ props.selectedValue }
              handleChangeSelectedValue={ props.handleChangeSelectedValue }
              work={ work }
              fontSizeIcon={ 18 }
              fontSizeLabel={ 18 }
              padding={ 12 }

            />
          </div>
        </div>
        <hr className={ style.hr } />
        <div className={ style.imageWrapper }>
          <div className={ style.groupeImage }>
            <div className={ style.image }><WebCamContainer cam={ props.cams[0] } ghaId={ props.ghaId } /></div>
            <div className={ style.image }><WebCamContainer cam={ props.cams[1] } ghaId={ props.ghaId } /></div>
          </div>
          <div className={ style.groupeImage }>
            <div className={ style.image }><WebCamContainer cam={ props.cams[2] } ghaId={ props.ghaId } /></div>
            <div className={ style.image }><WebCamContainer cam={ props.cams[3] } ghaId={ props.ghaId } /></div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
};

export default withStyles(styles)(dockOverloadModal);
